var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFlotaIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.217 8.754h-4.093V3.296H5.02a2.728 2.728 0 0 0-2.729 2.729v15.009h2.73a4.097 4.097 0 0 0 4.093 4.093 4.097 4.097 0 0 0 4.093-4.093h8.187a4.097 4.097 0 0 0 4.093 4.093 4.097 4.097 0 0 0 4.093-4.093h2.73v-6.822l-4.094-5.458ZM9.115 23.08a2.044 2.044 0 0 1-2.047-2.047c0-1.133.914-2.047 2.047-2.047 1.132 0 2.046.914 2.046 2.047a2.044 2.044 0 0 1-2.046 2.047Zm16.373 0a2.044 2.044 0 0 1-2.047-2.047c0-1.133.915-2.047 2.047-2.047 1.133 0 2.047.914 2.047 2.047a2.044 2.044 0 0 1-2.047 2.047Zm-1.364-8.87v-3.41h3.41l2.682 3.41h-6.093Z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2B363B",
    strokeLinejoin: "round",
    strokeWidth: 4.002,
    d: "M28.217 8.754h-4.093V3.296H5.02a2.728 2.728 0 0 0-2.729 2.729v15.009h2.73a4.097 4.097 0 0 0 4.093 4.093 4.097 4.097 0 0 0 4.093-4.093h8.187a4.097 4.097 0 0 0 4.093 4.093 4.097 4.097 0 0 0 4.093-4.093h2.73v-6.822l-4.094-5.458ZM9.115 23.08a2.044 2.044 0 0 1-2.047-2.047c0-1.133.914-2.047 2.047-2.047 1.132 0 2.046.914 2.046 2.047a2.044 2.044 0 0 1-2.046 2.047Zm16.373 0a2.044 2.044 0 0 1-2.047-2.047c0-1.133.915-2.047 2.047-2.047 1.133 0 2.047.914 2.047 2.047a2.044 2.044 0 0 1-2.047 2.047Zm-1.364-8.87v-3.41h3.41l2.682 3.41h-6.093Z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.628,
    cy: 6.464,
    r: 6.337,
    fill: "#2B363B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.676 7.105H7.298v2.437H6.05V7.105H3.672v-1.13H6.05V3.538h1.248v2.437h2.378v1.13Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1440v909H0z",
    transform: "translate(-848 -319)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFlotaIcon);
export default __webpack_public_path__ + "static/media/add-flota-icon.ff439edbf1988e8916b62c9b2763d817.svg";
export { ForwardRef as ReactComponent };